export interface DotScaleProps {
    fillColor: string;
    totalDots: number;
    dotScaleValue: number;
    headerText: string;
    bottomLeftLabel?: string;
    bottomRightLabel?: string;
}

const COMPONENT_CLASS = "c-dot-scale";

const DotScale: React.FunctionComponent<DotScaleProps> = (props) => {
    const {
        totalDots,
        dotScaleValue,
        headerText,
    } = props

    return (
        <div className={`${COMPONENT_CLASS}`} style={{ "--fill-color": props.fillColor ?? "#007bff" } as React.CSSProperties}
        >
            <div className={`${COMPONENT_CLASS}__header`}>
                <span className={`${COMPONENT_CLASS}__header-text`}>{headerText}</span>
                <span className={`${COMPONENT_CLASS}__header-scale`}>{props.dotScaleValue}/{props.totalDots}</span>
            </div>
            <div className={`${COMPONENT_CLASS}__dots-wrapper`}>
                {
                    Array.from({ length: totalDots }, (_, i) => i + 1).map((dotIndex) => (
                        <div className={`${COMPONENT_CLASS}__dot ${dotIndex <= dotScaleValue ? "filled" : ""}`} key={dotIndex}>
                        </div>
                    ))
                }
            </div>
            <div className={`${COMPONENT_CLASS}__labels-wrapper`}>
                <span>{props.bottomLeftLabel}</span>
                <span>{props.bottomRightLabel}</span>
            </div>
        </div>
    );
};

export default DotScale;